var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89684 6.8995C7.89684 9.09908 6.12905 10.8822 3.94849 10.8822C1.76793 10.8822 0 9.09868 0 6.8995C0 4.70032 1.76779 2.91667 3.94849 2.91667C6.12918 2.91667 7.89684 4.69991 7.89684 6.8995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2283 6.89949C12.2283 8.96992 11.3444 10.649 10.254 10.649C9.16368 10.649 8.27979 8.96992 8.27979 6.89949C8.27979 4.82905 9.16355 3.14996 10.2539 3.14996C11.3442 3.14996 12.2281 4.82851 12.2281 6.89949",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 6.89948C13.9999 8.75408 13.6891 10.2585 13.3055 10.2585C12.922 10.2585 12.6113 8.75448 12.6113 6.89948C12.6113 5.04447 12.9221 3.5405 13.3055 3.5405C13.6889 3.5405 13.9999 5.04434 13.9999 6.89948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.934f78accf873555c20f0e606a14dac8.svg";
export { ForwardRef as ReactComponent };